import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getRecoveryData } from '../actions/recoveryAction';

export interface RecoveryData {
  recoveryId: number;
  organisationId: number;
  firstName: string;
  lastName: string;
  cycleId: number;
  date: Date;
  dayOfWeek: string;
  restingHeartRate: number;
  heartRateVariability: number;
  recovery: number;
  sleepScore: number;
  sleepOnset: Date;
  wakeOnset: Date;
  hoursInBed: number;
  hoursOfSleep: number;
  sleepNeed: number;
  sleepEfficiency: number;
  wakePeriods: number;
  sleepDisturbances: number;
  latency: number;
  cycles: number;
  remSleepHours: number;
  deeplSleepHours: number;
  lightSleepHours: number;
  awakeHours: number;
  missingDataHours: number;
  sleepDebtHours: number;
  respiratoryRate: number;
  lastNapEndTime: Date;
  napTimeInBed: number;
  totalCycleNapTime: number;
  napDisturbances: number;
  napRemHours: number;
  napSwsHours: number;
  napLightHours: number;
  napWakeHours: number;
  napMissingDataHours: number;
  totalCycleTimeHours: number;
  timezoneOffset: string;
  oxygenSaturation: number;
  skinTemp: number;
  optimalSleepOnset: Date;
  optimalWakeOnset: Date;
  remPercentage: number;
  deepSleepPercentage: number;
  restorativeSleepHours: number;
  restorativeSleepPercentage: number;
  sleepConsistencyPercentage: number;
  shipId: number;
}

export interface RecoveryState {
  recoveryData: RecoveryData[];
  loading: boolean;
  error: string | null;
  searchResults: RecoveryData[] | undefined;
}

const initialState: RecoveryState = {
  recoveryData: [],
  loading: false,
  error: '',
  searchResults: undefined,
};

interface PayloadObject {
  yesterday: String;
  shipId: number;
}

const recoveryDataSlice = createSlice({
  name: 'recoveryData',
  initialState: initialState,
  reducers: {
    searchRecovery: (state: RecoveryState, action: PayloadAction<PayloadObject>) => { 
      state.searchResults = action.payload ? state.recoveryData.filter(
        r => r.date.toString().split("T")[0] == action.payload.yesterday).filter(
          r => r.shipId == action.payload.shipId
        ) : [];
    }
  },
  extraReducers: (builder) => {
    // load recoveryData
    builder.addCase(getRecoveryData.pending, (state: RecoveryState) => {
        state.loading = true
        state.error = null
    }),
    builder.addCase(getRecoveryData.fulfilled, (state: RecoveryState, { payload }: PayloadAction<RecoveryData[]>) => {
        state.loading = false
        state.recoveryData = payload
    }),
    builder.addCase(getRecoveryData.rejected, (state: RecoveryState, { payload }: PayloadAction<any>) => {
        state.loading = false
        state.error = payload
    })
  }
});

export const { searchRecovery } = recoveryDataSlice.actions;

export default recoveryDataSlice.reducer;